import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { withAccount } from '../../../../../components/AccountContext';
import FileList from './components/FileList';
import { dispatchGraphqlErrors, dispatchDefaultSuccess } from '../../../../../utils/NotificationUtil';

const mapDispatchToProps = dispatch => ({
  onUpdateSuccess: (message) => {
    dispatchDefaultSuccess(dispatch, message);
  },
  onUpdateFailed: (errors) => {
    dispatchGraphqlErrors(dispatch, errors);
  },
});

export default withRouter(
  injectIntl(
    connect(
      null,
      mapDispatchToProps,
    )(withAccount(FileList)),
  ),
);
